import { Component } from '@angular/core';
import { FeedbackPlatformReviewQuestionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Review Questions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformreviewquestion-form',
    templateUrl: './feedbackplatformreviewquestion.form.component.html'
})
export class FeedbackPlatformReviewQuestionFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformReviewQuestionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reviewQuestionRubrics', sectionName: 'Review Question Rubrics', isExpanded: false },
            { sectionKey: 'reviewResponses', sectionName: 'Review Responses', isExpanded: false },
            { sectionKey: 'nominationResponses', sectionName: 'Nomination Responses', isExpanded: false }
        ]);
    }
}

